import styled from "styled-components";

 export const MobileResponsive = styled.p`
  line-height:2;
    opacity: 0.7;
    
  @media (max-width: 768px) {
    display: none;
  }
`;

export const MobileResponsiveH3 = styled.h3`
@media (max-width: 768px) {
  display: none;
}
`;